import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	max-height: 400px;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	height: 100%;
	overflow: hidden;
`;

export const title = styled.div`
	width: 100%;
	text-align: left;
	font-size: 1.5rem;
	color: ${color.interface.lightGray};
`;

export const list = styled.div`
	width: 100%;
	padding-right: 5px;

	display: grid;
	grid-template-columns: repeat(4, 1fr);
	align-items: center;
	align-content: flex-start;
	justify-items: center;
	gap: 1.5rem;
	overflow: auto;
	padding-bottom: 1.5rem;

	@media (max-width: 1300px) {
		grid-template-columns: repeat(3, 1fr);
	}

	@media (max-width: 1000px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 400px) {
		grid-template-columns: repeat(1, 1fr);
	}
`;

interface ItemProps {
	$isSelected: boolean;
}

export const item = styled.div<ItemProps>`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	border: 2px solid
		${(props) =>
			props.$isSelected ? color.system.info : color.interface.darkgray2};
	border-radius: 5px;
	padding: 1.5rem;
	cursor: pointer;

	box-shadow: ${(props) =>
		props.$isSelected
			? `0px 0px 16px -7px ${color.system.info};`
			: '0px 0px 0px 0px rgba(0,0,0,0.75)'};

	> img {
		width: 100%;
		height: 100%;
		object-fit: contain;
		object-position: center;
	}

	> p {
		text-align: center;
		color: ${color.interface.lightGray};
		font-weight: 900;
		font-size: 1.3rem;
	}
`;
